import { ExperimentTreatment } from '@amzn/aapn-react-components/dist/Experiments/experiments_io'
import { Variation } from '../../../generated/graphql'

// List ongoing experiments in this file for easy reference throughout the rest of the code base.
//
// Example:
// export const FOO_EXPERIMENT_KEY = 'FOO_BAR'

// In order to add the experiment in url, use the following: ?aapn_ex_<feature_name>=T1

export const isFeatureEnabled = (treatment: ExperimentTreatment): boolean => treatment != Variation.C

export const LANGUAGE_PICKER_KEY = 'LANGUAGE_PICKER'
export const NON_ENDEMIC_KEY = 'NonEndemic'
export const API_REG_FORM_UPDATE = 'APIRegFormUpdate'
export const IE_MARKETPLACE_KEY = 'Ireland'
export const BETA_FEATURE_KEY = 'Beta'

export const evidentlyFeatures = [NON_ENDEMIC_KEY, API_REG_FORM_UPDATE, IE_MARKETPLACE_KEY, BETA_FEATURE_KEY]
